import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/emt-login'
import Home from '@/components/emt-home'
import User from '@/components/emt-form-user'
import EditUser from '@/components/emt-form-edit-user'
import Unit from '@/components/emt-form-unit'
import EditUnit from '@/components/emt-form-edit-unit'
import Area from '@/components/emt-form-area'
import EditArea from '@/components/emt-form-edit-area'
import Reason from '@/components/emt-form-reason'
import EditReason from '@/components/emt-form-edit-reason'
import Subreason from '@/components/emt-form-subreason'
import EditSubreason from '@/components/emt-form-edit-subreason'
import Company from '@/components/emt-form-company'
import EditCompany from '@/components/emt-form-edit-company'
import Channel from '@/components/emt-form-channel'
import EditChannel from '@/components/emt-form-edit-channel'
import DateNotAvailable from '@/components/emt-form-date-not-available'
import ConsultPqr from '@/components/emt-form-consult-pqr'
import RegisterPqr from '@/components/emt-form-register-pqr'
import UpdatePqr from '@/components/emt-form-update-pqr'
import Reassignment from '@/components/emt-reassignment'
import ChangePassword from '@/components/emt-change-password'
import Exports from '@/components/emt-form-export'
import Gender from '@/components/emt-form-gender'
import EditGender from '@/components/emt-form-edit-gender'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
            alias: '/login'
        },
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/User',
            name: 'User',
            component: User
        },
        {
            path: '/User/:id',
            name: 'EditUser',
            component: EditUser,
            props: true
        },
        {
            path: '/Unit',
            name: 'Unit',
            component: Unit
        },
        {
            path: '/Unit/:id',
            name: 'EditUnit',
            component: EditUnit,
            props: true
        },
        {
            path: '/Area',
            name: 'Area',
            component: Area
        },
        {
            path: '/Area/:id',
            name: 'EditArea',
            component: EditArea,
            props: true
        },
        {
            path: '/Reason',
            name: 'Reason',
            component: Reason
        },
        {
            path: '/EditReason/:id',
            name: 'EditReason',
            component: EditReason,
            props: true
        },
        {
            path: '/Subreason',
            name: 'Subreason',
            component: Subreason
        },
        {
            path: '/Subreason/:id',
            name: 'EditSubreason',
            component: EditSubreason,
            props: true
        },
        {
            path: '/Channel',
            name: 'Channel',
            component: Channel
        },
        {
            path: '/Channel/:id',
            name: 'EditChannel',
            component: EditChannel,
            props: true
        },
        {
            path: '/Company',
            name: 'Company',
            component: Company
        },
        {
            path: '/Company/:id',
            name: 'EditCompany',
            component: EditCompany,
            props: true
        },
        {
            path: '/DateNotAvailable',
            name: 'DateNotAvailable',
            component: DateNotAvailable
        },
        {
            path: '/ConsultPqr',
            name: 'ConsultPqr',
            component: ConsultPqr
        },
        {
            path: '/RegisterPqr',
            name: 'RegisterPqr',
            component: RegisterPqr
        },
        {
            path: '/UpdatePqr/:id',
            name: 'UpdatePqr',
            component: UpdatePqr,
            props: true
        },
        {
            path: '/Reassignment/:id',
            name: 'Reassignment',
            component: Reassignment,
            props: true
        },
        {
            path: '/ChangePassword/:id',
            name: 'ChangePassword',
            component: ChangePassword,
            props: true
        },
        {
            path: '/Export/',
            name: 'Exports',
            component: Exports,
            props: true
        },
        {
            path: '/Genero',
            name: 'Gender',
            component: Gender
        },
        {
            path: '/Genero/:id',
            name: 'EditGender',
            component: EditGender,
            props: true
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js